import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface ConfirmDialogData {
    title: string;
    text: string;
    cancelLabel?: string;
    confirmLabel?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['../dialog.styles.scss'],
})
export class ConfirmDialogComponent implements AfterViewInit {
    public title!: string;
    public text!: string;
    public cancelLabel!: string;
    public confirmLabel!: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
        private cd: ChangeDetectorRef
    ) {
        this.title = data.title;
        this.text = data.text;
        this.cancelLabel = data.cancelLabel || 'Annuleren';
        this.confirmLabel = data.confirmLabel || 'Ok';
    }

    public ngAfterViewInit() {
        this.cd.detectChanges();
    }
}
